export default __webpack_public_path__ + "static/media/Hot_Swing.0a27cfbd.mp3";